import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function Terms() {
  return (
    <div className="min-h-screen bg-bg text-ink" data-testid="terms-page">
      <header className="border-b border-line">
        <div className="max-w-3xl mx-auto px-5 py-4 flex items-center justify-between">
          <Link to="/" className="text-sm font-bold inline-flex items-center gap-1.5 text-ink-soft hover:text-brand"><ArrowLeft className="w-4 h-4"/> Back</Link>
          <img src="/brand/petbond-logo.png" alt="PetBond" className="h-10"/>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-5 py-12 prose prose-sm">
        <h1 className="font-heading text-4xl font-extrabold">Terms of Service</h1>
        <p className="text-ink-soft text-sm">Last updated: {new Date().toLocaleDateString("en-IN", { day: "numeric", month: "long", year: "numeric" })}</p>

        <h2 className="font-heading text-2xl font-extrabold mt-8">1. Welcome to PetBond</h2>
        <p>PetBond ("we", "us", "our") operates the website <a href="https://www.petbond.in">www.petbond.in</a> and the PetBond mobile/web application (the "Service"). By using the Service, you agree to these Terms. If you don't agree, please don't use the Service.</p>

        <h2 className="font-heading text-2xl font-extrabold mt-8">2. Who can use PetBond</h2>
        <p>You must be at least 18 years old (or have parental consent) to create an account. By signing in, you confirm the information you provide is accurate and yours.</p>

        <h2 className="font-heading text-2xl font-extrabold mt-8">3. Pet records, vet appointments & AI advice</h2>
        <p>PetBond enables you to book appointments with independent veterinary professionals, store pet records, and chat with our AI assistant "Dr. PetBond". <b>The AI assistant is for informational purposes only and is NOT a substitute for professional veterinary care.</b> Always consult a licensed veterinarian for diagnosis and treatment, especially in emergencies.</p>
        <p>We are not liable for the conduct of independent vet clinics, stores, hostels, or NGOs listed on our platform. We verify KYC documents but cannot guarantee outcomes of services delivered by third parties.</p>

        <h2 className="font-heading text-2xl font-extrabold mt-8">4. Payments & subscriptions</h2>
        <p>Premium subscriptions are billed via secure payment gateways (Razorpay / Stripe). Free trials auto-convert to paid plans only if a payment method is provided. You can cancel anytime from Billing → Subscription. Refunds are handled case-by-case at <a href="mailto:hello@petbond.in">hello@petbond.in</a>.</p>
        <p>Donations to NGOs are routed directly to the NGO. PetBond does not retain a platform fee from verified NGO donations.</p>

        <h2 className="font-heading text-2xl font-extrabold mt-8">5. Acceptable use</h2>
        <ul>
          <li>No spam, abuse, harassment of vets/NGOs/pet parents</li>
          <li>No false lost-pet reports, no impersonation</li>
          <li>No uploading offensive, illegal or copyrighted media</li>
          <li>No attempts to scrape, reverse-engineer, or overload the Service</li>
        </ul>

        <h2 className="font-heading text-2xl font-extrabold mt-8">6. Account termination</h2>
        <p>We may suspend or terminate accounts that violate these Terms. You may delete your account anytime by writing to <a href="mailto:hello@petbond.in">hello@petbond.in</a>.</p>

        <h2 className="font-heading text-2xl font-extrabold mt-8">7. Limitation of liability</h2>
        <p>To the maximum extent permitted by law, PetBond is provided "as-is". We are not liable for indirect, incidental or consequential damages, including loss of pets, missed appointments, or AI-misguided advice. Use the Service at your own discretion and always rely on professional veterinary care for medical decisions.</p>

        <h2 className="font-heading text-2xl font-extrabold mt-8">8. Governing law</h2>
        <p>These Terms are governed by the laws of India. Disputes will be subject to the exclusive jurisdiction of courts in Mumbai, India.</p>

        <h2 className="font-heading text-2xl font-extrabold mt-8">9. Contact</h2>
        <p>Questions? Reach us at <a href="mailto:hello@petbond.in">hello@petbond.in</a> or <a href="tel:+919819793270">+91 98197 93270</a>.</p>
      </main>
    </div>
  );
}
